import React, { createContext, useReducer, useContext } from 'react';
import { useUserContext } from './UserContext';

const OrderContext = createContext({});
const initialState = {
  orders: [],
  archived: [],
  loading: false,
  hostname: process.env.REACT_APP_API_URL || '',
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_LOADING':      return { ...state, loading: action.payload };
    case 'GET_ORDERS':       return { ...state, orders: action.payload, loading: false };
    case 'GET_ARCHIVED':     return { ...state, archived: action.payload, loading: false };
    case 'ADD_ORDER':        return { ...state, orders: [action.payload, ...state.orders] };
    case 'UPDATE_ORDER':     return {
        ...state,
        orders: state.orders.map(o =>
          o._id === action.payload._id ? { ...o, ...action.payload } : o
        ),
        archived: state.archived.map(o =>
          o._id === action.payload._id ? { ...o, ...action.payload } : o
        ),
      };
    case 'REMOVE_ORDER':     return {
      ...state,
      orders: state.orders.filter(o => o._id !== action.payload),
      archived: state.archived.filter(o => o._id !== action.payload),
    };
    case 'MOVE_TO_ARCHIVE':
      return {
        ...state,
        orders: state.orders.filter(o => o._id !== action.payload._id),
        archived: [action.payload, ...state.archived.filter(o => o._id !== action.payload._id)],
      };

    case 'MOVE_FROM_ARCHIVE':
      return {
        ...state,
        archived: state.archived.filter(o => o._id !== action.payload._id),
        orders: [action.payload, ...state.orders.filter(o => o._id !== action.payload._id)],
      };
    default: return state;
  }
};

export const OrderProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const { logout } = useUserContext();

  const authHeaders = () => ({
    'Content-Type': 'application/json',
    'x-access-token': JSON.parse(localStorage.getItem('authToken') || '{}').token,
  });
  const checkAuth = (data) => { if (data?.isLoggetIn === false) logout(); };

  const fetchOrders = async () => {
    dispatch({ type: 'SET_LOADING', payload: true });
    try {
      const res = await fetch(`${initialState.hostname}/orders/getorders`, { headers: authHeaders() });
      const data = await res.json();
      checkAuth(data);
      dispatch({ type: 'GET_ORDERS', payload: data.data || [] });
    } catch (e) { console.error(e); dispatch({ type: 'SET_LOADING', payload: false }); }
  };

  const fetchArchived = async () => {
    dispatch({ type: 'SET_LOADING', payload: true });
    try {
      const res = await fetch(`${initialState.hostname}/orders/getarchived`, { headers: authHeaders() });
      const data = await res.json();
      checkAuth(data);
      dispatch({ type: 'GET_ARCHIVED', payload: data.data || [] });
    } catch (e) { console.error(e); dispatch({ type: 'SET_LOADING', payload: false }); }
  };

  const fetchNextNumber = async () => {
    const res = await fetch(`${initialState.hostname}/orders/next-number`, { headers: authHeaders() });
    const data = await res.json();
    checkAuth(data);
    return data.number || '000001';
  };

  const addOrder = async (body) => {
    const res = await fetch(`${initialState.hostname}/orders/create`, {
      method: 'POST', headers: authHeaders(), body: JSON.stringify(body),
    });
    const data = await res.json();
    checkAuth(data);
    if (data.data._id) {
      dispatch({ type: 'ADD_ORDER', payload: { ...body, _id: data.data._id, archived: false } });
      return data;
    }
    throw new Error(data.message || 'Не удалось создать заказ');
  };

  const updateOrder = async (id, body) => {
    const res = await fetch(`${initialState.hostname}/orders/update/${id}`, {
      method: 'PUT', headers: authHeaders(), body: JSON.stringify(body),
    });
    const data = await res.json();
    checkAuth(data);
    debugger
    if (res.ok) {
      dispatch({ type: 'UPDATE_ORDER', payload: { ...body, _id: id } });
      return data;
    }
    throw new Error(data.message || 'Не удалось сохранить');
  };

  const archiveOrder = async (id, body) => {
    // Меняем статус на «архивный» через update и параллельно ставим archived
    const res = await fetch(`${initialState.hostname}/orders/update/${id}`, {
      method: 'PUT', headers: authHeaders(),
      body: JSON.stringify({ ...body, archived: true }),
    });
    const data = await res.json();
    checkAuth(data);
    debugger
    if (res.ok) {
      const archivedOrder = { ...body, _id: id, archived: true };
      dispatch({ type: 'MOVE_TO_ARCHIVE', payload: archivedOrder });
    }
    return data;
  };

  const unarchiveOrder = async (id, body) => {
    const res = await fetch(`${initialState.hostname}/orders/update/${id}`, {
      method: 'PUT', headers: authHeaders(),
      body: JSON.stringify({ ...body, archived: false }),
    });
    const data = await res.json();
    checkAuth(data);
    debugger
    if (res.ok) {
      const restored = { ...body, _id: id, archived: false };
      dispatch({ type: 'MOVE_FROM_ARCHIVE', payload: restored });
    }
    return data;
  };

  const deleteOrder = async (id) => {
    const res = await fetch(`${initialState.hostname}/orders/delete/${id}`, {
      method: 'DELETE', headers: authHeaders(),
    });
    const data = await res.json();
    checkAuth(data);
    debugger
    if (res.ok) dispatch({ type: 'REMOVE_ORDER', payload: id });
    return data;
  };

  return (
    <OrderContext.Provider value={{
      ...state,
      fetchOrders, fetchArchived, fetchNextNumber,
      addOrder, updateOrder, archiveOrder, unarchiveOrder, deleteOrder,
    }}>
      {children}
    </OrderContext.Provider>
  );
};

export const useOrderContext = () => useContext(OrderContext);